const handler = tracker => ({
  trackOpenProject: metadata => {
    tracker().trackEvent("Ha abierto un proyecto", metadata)
  }
})

export default handler